import React, { useEffect, useState } from "react";
import { Reveal, SectionHeader } from "@/components/ui-blocks/Reveal";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { api, endpoints } from "@/lib/api";
import { Quote } from "lucide-react";

export const SuccessStories = () => {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get(endpoints.successStories).then(setItems).catch(() => {}); }, []);
  return (
    <section className="bg-background">
      <div className="container-wide py-16 lg:py-24">
        <SectionHeader eyebrow="Success Stories" title="Human stories behind every number." lead="The people we serve are the reason we exist. Here are a few whose lives changed this quarter." />
        <Carousel opts={{ align: "start", loop: true }} className="w-full">
          <CarouselContent>
            {items.map((s, i) => (
              <CarouselItem key={s.id} className="md:basis-1/2 lg:basis-1/3">
                <Reveal delay={i * 0.05}>
                  <article className="h-full rounded-xl border border-[hsl(var(--border))] overflow-hidden bg-card" data-testid={`success-story-${s.id}`}>
                    <div className="aspect-[4/3] overflow-hidden"><img src={s.image} loading="lazy" alt={s.name} className="h-full w-full object-cover" /></div>
                    <div className="p-5">
                      <Quote className="h-5 w-5 text-[hsl(var(--orange))]" />
                      <h3 className="heading-3 mt-2 text-lg">{s.name}</h3>
                      <p className="text-sm text-[hsl(var(--muted-ink))] mt-2">{s.summary}</p>
                    </div>
                  </article>
                </Reveal>
              </CarouselItem>
            ))}
          </CarouselContent>
          <div className="hidden md:flex"><CarouselPrevious /><CarouselNext /></div>
        </Carousel>
      </div>
    </section>
  );
};
